/* tslint:disable */
/* eslint-disable */
/**
 * Risks API
 * API for managing risks.
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ContractTenantDocumentFile
 */
export interface ContractTenantDocumentFile {
    /**
     * 
     * @type {string}
     * @memberof ContractTenantDocumentFile
     */
    storedFileId: string;
    /**
     * 
     * @type {string}
     * @memberof ContractTenantDocumentFile
     */
    fileName: string;
}

/**
 * Check if a given object implements the ContractTenantDocumentFile interface.
 */
export function instanceOfContractTenantDocumentFile(value: object): value is ContractTenantDocumentFile {
    if (!('storedFileId' in value) || value['storedFileId'] === undefined) return false;
    if (!('fileName' in value) || value['fileName'] === undefined) return false;
    return true;
}

export function ContractTenantDocumentFileFromJSON(json: any): ContractTenantDocumentFile {
    return ContractTenantDocumentFileFromJSONTyped(json, false);
}

export function ContractTenantDocumentFileFromJSONTyped(json: any, ignoreDiscriminator: boolean): ContractTenantDocumentFile {
    if (json == null) {
        return json;
    }
    return {
        
        'storedFileId': json['storedFileId'],
        'fileName': json['fileName'],
    };
}

export function ContractTenantDocumentFileToJSON(json: any): ContractTenantDocumentFile {
    return ContractTenantDocumentFileToJSONTyped(json, false);
}

export function ContractTenantDocumentFileToJSONTyped(value?: ContractTenantDocumentFile | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'storedFileId': value['storedFileId'],
        'fileName': value['fileName'],
    };
}

